!((document, Drupal, $) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.videoBackground = {
    attach: function (context) {
      const els = $('.video-background', context);
      const config = {
        attributes: true, childList: false, subtree: false,
        attributeOldValue: true,
        attributeFilter: ['class']
      };

      els.each(function () {
        const paragraphId = $(this).data('paragraph-id');
        const options = {
          muted: true,
          autoplay: true,
          controls: false,
          loop: true,
          fluid: true,
          background: true
        };

        let player = videojs('player' + paragraphId, options);
        player.play();

        // Set Mutation Observer
        let observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            const el = mutation.target;
            if (el.classList.contains('offsetIn')) {
              if (!player) {
                player = videojs('player' + paragraphId, options);
              }
              player.play();
            }
            else {
              if (player.currentTime() > 1) {
                player.pause();
              }
            }
          });
        });
        observer.observe(this.closest('.section__item__video-background'), config);
      });
    }
  };
})(document, Drupal, jQuery);

